<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
    :resource="resource"
    :settings="settings"
    @settings-gen-changed="handleSettingsGenChange"
  >
    <template v-slot:display>
      <b-container>
        <display :resource="resource" @appLog="appLog" />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
        :resource="resource"
        :settings="settings"
        @resource-updated="handleRefreshResource"
        @settings-user-changed="handleSettingsUserChange"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBlockIndex from "@/mixins/resourceBlocks/Index";
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
export default {
  name: "Resource_Tracker",
  mixins: [ResourceBlockIndex],
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
